import React from 'react';
import classes from './SideMenuItem.module.css';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

const sideMenuItem = (props) => {
  const badgeStyle = {display: props.counter > 0 ? 'flex' : 'none'};
  const navLinkClasses = [classes.NavLink];
  if (props.className) {
    navLinkClasses.push(props.className);
  }

  return (
    <NavLink
      to={props.to}
      onClick={props.clicked}
      activeClassName={classes.Active}
      className={cn(navLinkClasses)}
    >
      <div className={classes.MenuWrapper} style={props.styleMenuWrapper}>
        <div className={classes.IconWrapper}>
          <div style={badgeStyle} className={classes.Badge}>
            <span className={classes.BadgeNumber}>{props.counter}</span>
          </div>
          <div className={classes.Icon}>
            <svg style={{fill: props.fill}} className={classes.IconSvg}><use xlinkHref={props.img} /></svg>
          </div>
        </div>
        <div className={classes.Txt}>
          {props.strings}
        </div>
      </div>
    </NavLink>
  );
};

export default sideMenuItem;
